export default {
  '1': { name: 'Monthly', value: 1 },
  '2': { name: 'Quarterly', value: 3 },
  '3': { name: 'Half-yearly', value: 6 },
  '4': { name: 'Annual', value: 12 },
};
